import { render } from "./ShiftStart.vue?vue&type=template&id=ffade682&scoped=true&lang=true"
import script from "./ShiftStart.vue?vue&type=script&lang=js"
export * from "./ShiftStart.vue?vue&type=script&lang=js"

import "./ShiftStart.vue?vue&type=style&index=0&id=ffade682&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffade682"]])

export default __exports__